import React from 'react';
import uniqueId from '../../../forms/utilities/unique-id';
import { useErrors } from './ErrorsContext';
import Hint from './Hint';
import ValidationError from './ValidationError';

export default function ChoiceQuestion({
    name,
    label = 'Unlabelled',
    value = '',
    onChange = () => {},
    hint = null,
    options = [],
}) {
    const { errors } = useErrors();

    return <div>
        <fieldset>
            <legend className="text-sm">
                { label }
            </legend>

            <Hint hint={ hint } />

            <div className="mt-4 space-y-3">
                {options.map(option => {
                    const id = uniqueId()

                    return <div key={ id } className="flex items-center space-x-2">
                        <input onChange={event => onChange(event.target.value)} checked={ option.value === value } className="styled-input form-dot" id={ id } name={ name } value={ option.value } type="radio" />
                        <label className="text-grey-500 text-sm" htmlFor={ id }>{ option.label }</label>
                    </div>
                })}
            </div>
        </fieldset>

        <ValidationError errors={ errors} name={ name } />
    </div>;
}
